<div class="page-container">
    @if (wizardSteps) {
        <div class="wizard">
            <div class="logo">
                <img src="../../../assets/img/logo.png" [alt]="'general.brandLogo' | translate" />
            </div>
            <div class="backlink">
                <span class="material-icons">arrow_back</span>
                <a [href]="backLinkUrl">onego.io</a>
            </div>
            <div class="dialog">
                <div class="page-image">
                    <img [src]="'assets/img/' + step.image" [alt]="'steps.titles.' + step.title | translate" />
                    @if (currentStep === 2) {
                        <span class="page-image-tenant">{{ formData.tenantName }}</span>
                    }
                </div>
                <div class="steps">
                    <h1 class="steps-title">
                        {{ 'steps.titles.' + step.title | translate }}
                    </h1>
                    <span class="steps-number">
                        {{
                            'steps.stepXOfTotal'
                                | translate
                                    : {
                                          stepNumber: calculatedValues.visibleStepIndex,
                                          totalSteps,
                                      }
                        }}
                    </span>
                    <span class="steps-bar">
                        <span class="steps-bar-fill" [style.width]="calculatedValues.barFillPercentage"></span>
                    </span>
                </div>
                <div class="form">
                    <app-wizard-step-create-account [form]="formData" (stepSubmit)="nextStep()" />
                    <app-wizard-step-login [form]="formData" (stepSubmit)="nextStep()" />
                    <app-wizard-step-tenant [form]="formData" (stepSubmit)="nextStep()" />
                    <app-wizard-step-location [form]="formData" (stepSubmit)="nextStep()" />
                    <app-wizard-step-done [form]="formData" (stepSubmit)="nextStep()" />
                </div>
                <div class="controls">
                    @if (!step.component()?.nextPageLink) {
                        <button
                            type="button"
                            class="btn color-secondary"
                            (click)="nextStep()"
                            [disabled]="nextDisabled"
                        >
                            @if (!nextDisabled) {
                                <span @fade>
                                    {{ 'buttons.' + step.component()?.nextButtonLabel | translate }}
                                </span>
                            }
                            @if (nextDisabled) {
                                <ogs-spinner @fade />
                            }
                        </button>
                    }
                    @if (step.component()?.nextPageLink) {
                        <a [href]="step.component()?.nextPageLink" target="_blank" class="btn color-secondary">
                            {{ 'buttons.' + step.component()?.nextButtonLabel | translate }}
                        </a>
                    }
                </div>
            </div>
        </div>
    }
</div>
